module.exports = {
  initSpace(){
    var canvas;
    var context;
    var screenH;
    var screenW;
    var stars = [];
    var fps = 50;
    var numStars = 2000;
      
    // Calculate the screen size
    screenW = window.innerWidth;
    screenH = window.innerHeight;
    
    // Get the canvas
    canvas = document.getElementById('starsCanvas');
    
    // Fill out the canvas
    canvas.width = screenW;
    canvas.height = screenH;
    context = canvas.getContext('2d');
    
    // Create all the stars
    function redraw()
    {
      stars = [];
      for(var i = 0; i < numStars; i++) {
        var x = Math.round(Math.random() * screenW);
        var y = Math.round(Math.random() * screenH);
        var length = 1 + Math.random() * 2;
        var opacity = Math.random();
        
        // Create a new star and draw
        var star = new Star(x, y, length, opacity);
        
        // Add the the stars array
        stars.push(star);
      }
    }

    setInterval(animate, 1000 / fps);


    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      redraw();
    }
    window.addEventListener('resize', resizeCanvas, false);
    redraw();

    /**
     * Animate the canvas
     */
    function animate() {
      context.clearRect(0, 0, screenW, screenH);
      stars.forEach(function(star) {
        star.draw(context);
      });
    }

    /**
     * Star
     * 
     * @param int x
     * @param int y
     * @param int length
     * @param opacity
     */
    function Star(x, y, length, opacity) {
      this.x = parseInt(x);
      this.y = parseInt(y);
      this.length = parseInt(length);
      this.opacity = opacity;
      this.factor = 1;
      this.increment = Math.random() * .03;
    }

    /**
     * Draw a star
     * 
     * This function draws a start.
     * You need to give the contaxt as a parameter 
     * 
     * @param context
     */
    Star.prototype.draw = function() {
      context.rotate((Math.PI * 1 / 10));
      
      // Save the context
      context.save();
      
      // move into the middle of the canvas, just to make room
      context.translate(this.x, this.y);
      
      // Change the opacity
      if(this.opacity > 1) {
        this.factor = -1;
      }
      else if(this.opacity <= 0) {
        this.factor = 1;
        
        this.x = Math.round(Math.random() * screenW);
        this.y = Math.round(Math.random() * screenH);
      }
        
      this.opacity += this.increment * this.factor;
      
      context.beginPath()
      for (var i = 4; i--;) {
        context.lineTo(0, this.length);
        context.translate(0, this.length);
        context.rotate((Math.PI * 2 / 8));
        context.lineTo(0, - this.length);
        context.translate(0, - this.length);
        context.rotate(-(Math.PI * 6 / 8));
      }
      context.lineTo(0, this.length);
      context.closePath();
      context.fillStyle = "rgba(255, 255, 255, " + this.opacity + ")";
      context.shadowBlur = 5;
      context.fill();
      
      context.restore();
    }
  },

  initPoints(){
    var mapImageRealWidth = 1150;
    var mapImageRealHeight = 700;
    var planetMarkers = document.getElementsByClassName('planet-markers');
    var i = 0;
    var j = 0;
    
    for(i = 0; i < planetMarkers.length; i++) {
      var localMarkers = planetMarkers[i];
      var localPoints = localMarkers.getElementsByTagName('a');
      for(j = 0; j < localPoints.length; j++) {

        // Determine each point x,y position
        localPoints[j].style.left = 100 * localPoints[j].dataset.x / mapImageRealWidth + '%';
        localPoints[j].style.top = 100 * localPoints[j].dataset.y / mapImageRealHeight + '%';
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/Problems-planet-space.js